module.exports = global["clientConfig"] = require("-!/builds/orpo/ecpe/ecpe-portal-frontend/node_modules/exports-loader/index.js?clientConfig!/builds/orpo/ecpe/ecpe-portal-frontend/node_modules/babel-loader/lib/index.js?compact=false!./mdmAliases.template.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?clientConfig!./~/exports-loader?clientConfig!./client/config/mdmAliases.template.js
// module id = 48
// module chunks = 0